import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useLazyQuery, useMutation } from "@apollo/client";
import { SURVEY_BY_ID } from "../../GraphQL/Queries";
import {
  DECRIPT_PARAMETERS,
  SAVE_ANSWERS_SURVEY_AGENT,
  ADD_FEED_BACK,
} from "../../GraphQL/Mutations";
import FillOutSurvey from "../../components/FillOutSurvey";
import { GetURLParameter } from "../../util/UtilityFunctions";
import PortalModal from "../../Portals";
import {
  ContentModalSaveSurveyAnswer,
  ButtonSurveyAnswer,
  TextModalSurveyAnswer,
  CloseModalSurveyAnswer,
  SizeImgRating,
  ButtonCancelSurvey,
} from "./FillOutSurveyContainer.styled";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@material-ui/icons/ThumbDownAltOutlined";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import { getFile, uploadPDFAndImgFiles } from "../../services/FileManager";
import { getStateLogin, getStateLoginComplete } from "../LayoutHome/stateLogin";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import { NotificationManager } from "react-notifications";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import { ReactComponent as CopyIcon } from "../../assets/svg/copy-content-icon.svg";
import { IconButton } from "@material-ui/core";
import PropTypes from "prop-types";

const FillOutSurveyContainer = ({
  paramProp,
  previewProp,
  isAnonymousProp,
}) => {
  let Token = paramProp ? paramProp : GetURLParameter("ParamToken");
  let preview = previewProp ? previewProp : GetURLParameter("Preview");
  let isAnonymous = isAnonymousProp
    ? isAnonymousProp
    : GetURLParameter("isAnonymous");
  const [showAnonymous, setShowAnonymous] = useState(isAnonymous === "true");
  let form = GetURLParameter("itsForm") ?? null;
  const [allData, setAllData] = useState();
  let Random = false;
  const [randomDone, setRandomDone] = useState(false);
  const [surveyRating, setSurveyRating] = useState(0);
  const refDescription = useRef("");
  const history = useHistory();
  let [surveyQuestionData, setSurveyQuestionData] = useState([]);
  const [answersDependent, setAnswersDependent] = useState([]);
  const [GetSurvey] = useMutation(DECRIPT_PARAMETERS);
  const [runQuerySurveyById] = useLazyQuery(SURVEY_BY_ID, {
    fetchPolicy: "network-only",
    onCompleted: (data) => setAllData(data),
  });
  const [banners, setBanners] = useState([]);
  const [imagesChoice, setImagesChoice] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [anonymousId, setAnonymousId] = useState();

  useEffect(() => {
    GetSurvey({
      variables: {
        Token: Token,
      },
    }).then((res) => {
      runQuerySurveyById({
        variables: {
          idSurvey: parseInt(res.data.decriptParameters),
        },
      });
    });
  }, []);

  let arrayImageRating = [];
  const surveyData = allData && allData.surveyById;

  Random =
    allData && allData.surveyById && allData.surveyById.setRandomQuestions;

  useEffect(() => {
    if (
      allData &&
      allData.surveyById &&
      allData.surveyById.tpsurveyQuestionSurveys.length
    ) {
      if (Random) {
        if (!randomDone) {
          let tempParents = JSON.parse(
            JSON.stringify(
              allData.surveyById.tpsurveyQuestionSurveys
                .filter((i) => i.active === true && i.isDependent === false)
                .sort(() => 0.5 - Math.random())
            )
          );
          let tempDependent = allData.surveyById.tpsurveyQuestionSurveys.filter(
            (i) => i.active === true && i.isDependent === true
          );
          tempDependent.forEach((m, i) => {
            let positionFather = tempParents.findIndex(
              (f) => f.idQuestionSurvey === m.idParentQuestion
            );
            tempParents.splice(
              positionFather + 1,
              0,
              JSON.parse(JSON.stringify(m))
            );
          });
          tempParents.forEach((m, i) => {
            m.order = i + 1;
          });
          setSurveyQuestionData([...tempParents]);
        }
      } else {
        setSurveyQuestionData([
          ...allData.surveyById.tpsurveyQuestionSurveys.filter(
            (i) => i.active === true
          ),
        ]);
      }
    }
  }, [Random, allData, randomDone]);

  let titleConfiguration =
    allData &&
    allData.surveyById &&
    allData.surveyById.tpsurveyConfigurationSurveys
      ? allData.surveyById.tpsurveyConfigurationSurveys.filter(
          (T) => T.field === "Title"
        )
      : null;
  let footerConfiguration =
    allData &&
    allData.surveyById &&
    allData.surveyById.tpsurveyConfigurationSurveys
      ? allData.surveyById.tpsurveyConfigurationSurveys.filter(
          (T) => T.field === "Footer"
        )
      : null;
  let buttonSaveConfiguration =
    allData &&
    allData.surveyById &&
    allData.surveyById.tpsurveyConfigurationSurveys
      ? allData.surveyById.tpsurveyConfigurationSurveys.filter(
          (T) => T.field === "TextButtonSave"
        )
      : null;
  let backgroundConfiguration =
    allData &&
    allData.surveyById &&
    allData.surveyById.tpsurveyConfigurationSurveys
      ? allData.surveyById.tpsurveyConfigurationSurveys.filter(
          (T) => T.field === "Background"
        )
      : null;
  let logoConfiguration =
    allData &&
    allData.surveyById &&
    allData.surveyById.tpsurveyConfigurationSurveys
      ? allData.surveyById.tpsurveyConfigurationSurveys.filter(
          (T) => T.field === "Logo"
        )
      : null;
  let questionsConfiguration =
    allData &&
    allData.surveyById &&
    allData.surveyById.tpsurveyConfigurationSurveys
      ? allData.surveyById.tpsurveyConfigurationSurveys.filter(
          (T) => T.field === "Questions"
        )
      : null;
  let answerConfiguration =
    allData &&
    allData.surveyById &&
    allData.surveyById.tpsurveyConfigurationSurveys
      ? allData.surveyById.tpsurveyConfigurationSurveys.filter(
          (T) => T.field === "Answer"
        )
      : null;

  titleConfiguration =
    titleConfiguration && titleConfiguration[0]
      ? JSON.parse(titleConfiguration[0].jsonConfiguration)
      : titleConfiguration;
  footerConfiguration =
    footerConfiguration && footerConfiguration[0]
      ? JSON.parse(footerConfiguration[0].jsonConfiguration)
      : footerConfiguration;
  buttonSaveConfiguration =
    buttonSaveConfiguration && buttonSaveConfiguration[0]
      ? JSON.parse(buttonSaveConfiguration[0].jsonConfiguration)
      : buttonSaveConfiguration;
  backgroundConfiguration =
    backgroundConfiguration && backgroundConfiguration[0]
      ? JSON.parse(backgroundConfiguration[0].jsonConfiguration)
      : backgroundConfiguration;
  logoConfiguration =
    logoConfiguration && logoConfiguration[0]
      ? JSON.parse(logoConfiguration[0].jsonConfiguration)
      : logoConfiguration;
  questionsConfiguration =
    questionsConfiguration && questionsConfiguration[0]
      ? JSON.parse(questionsConfiguration[0].jsonConfiguration)
      : questionsConfiguration;
  answerConfiguration =
    answerConfiguration && answerConfiguration[0]
      ? JSON.parse(answerConfiguration[0].jsonConfiguration)
      : answerConfiguration;

  const [SaveAnswersSurveyAgent] = useMutation(SAVE_ANSWERS_SURVEY_AGENT);
  const [addfeedback] = useMutation(ADD_FEED_BACK);

  const [QuestionsSave, setQuestionsSave] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openErrorModal, setopenErrorModal] = useState(false);
  const [mandatoryMissing, setmandatoryMissing] = useState([]);

  const [bannersSend] = useState([]);
  const [imgBackground, setimgBackground] = useState("");
  const [logoSurvey, setlogoSurvey] = useState("");

  const [sigleImageSend] = useState([]);

  useEffect(() => {
    if (
      allData &&
      allData.surveyById &&
      allData.surveyById.tpsurveyQuestionSurveys.length
    ) {
      if (Random) {
        if (!randomDone) {
          if (surveyQuestionData.length >= 1) {
            setRandomDone(true);
          }
        }
      }
    }
  }, [Random, allData, randomDone, surveyQuestionData]);

  useEffect(() => {
    if (
      backgroundConfiguration &&
      backgroundConfiguration.nameImage &&
      backgroundConfiguration.nameImage !== "" &&
      imgBackground === ""
    ) {
      setimgBackground("send");
      getFile(backgroundConfiguration.nameImage).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setimgBackground(URL.createObjectURL(response));
        }
      });
    }
  }, [backgroundConfiguration, imgBackground]);

  useEffect(() => {
    if (
      logoConfiguration &&
      logoConfiguration.nameImage !== "" &&
      logoSurvey === ""
    ) {
      setlogoSurvey("send");
      getFile(logoConfiguration.nameImage).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setlogoSurvey(URL.createObjectURL(response));
        }
      });
    }
  }, [logoConfiguration, logoSurvey]);

  const uploadAFile = (file, folderName, Q) => {
    setShowLoader(true);
    return uploadPDFAndImgFiles(file, folderName)
      .then((res) => {
        let arrayNames = JSON.parse(res);
        return arrayNames[0].newName;
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const objectToSendAsAnswer = async () => {
    const user = getStateLogin();
    const answers = await Promise.all(QuestionsSave.map(async (Q) => {
      let file = Q.typeQuestion === "File" && Q.file?.target?.files[0];
  
      if (file) {
        let obj = await uploadAFile(file, "/Forms", Q);
  
        return {
          idQuestion: Q.idQuestion,
          idSurvey: Q.idSurvey,
          titleAnswer: Q.titleAnswer || "",
          answerClient: Q.answerClient.toString(),
          createUser: user,
          code: 0,
          file: obj,
        };
      } else {
        return {
          idQuestion: Q.idQuestion,
          idSurvey: Q.idSurvey,
          titleAnswer: Q.titleAnswer || "",
          answerClient: Q.answerClient.toString(),
          createUser: user,
          code: 0,
        };
      }
    }));
  
    setShowLoader(false);
    return answers;
  };

  const handleSaveSurvey = () => {
    let mandatory = [];

    surveyQuestionData
      .filter((m) => {
        return (
          (m.isDependent === false && m.isMandatory === true) ||
          (m.isMandatory === true &&
            m.isDependent &&
            answersDependent.findIndex(
              (f) =>
                f.idQuestionSurvey === m.idParentQuestion &&
                f.answer === m.dependentAnswer
            ) > -1)
        );
      })
      .forEach((x) => {
        let exists = QuestionsSave.filter((q) => {
          return q.idQuestion === x.idQuestion && q.answerClient;
        });

        if (exists.length === 0) {
          mandatory.push(x.idQuestion);
        }
      });

    if (mandatory.length > 0) {
      setmandatoryMissing(mandatory);
      setopenErrorModal(true);
      return;
    }

    let answeredAll = true;
    answeredAll = QuestionsSave.every((x) => {
      if (!x.answerClient) {
        return false;
      }
      return true;
    });

    if (
      QuestionsSave &&
      QuestionsSave.length <= surveyQuestionData.length &&
      !answeredAll
    ) {
      setWarningModal(true);
    } else {
      saveSurveyAnswer();
    }
  };

  const saveSurveyAnswer = async () => {
    let user_complete = getStateLoginComplete();
    let answerClients = await objectToSendAsAnswer();
    let openSurveyDate = localStorage.getItem("openSurveyDate");
    let idSurveyScheduling = parseInt(
      localStorage.getItem("idSurveyScheduling")
    );
    setShowLoader(true);
    SaveAnswersSurveyAgent({
      variables: {
        idSurvey: allData?.surveyById.idSurvey,
        idSurveyScheduling: idSurveyScheduling,
        openSurveyDate: new Date(openSurveyDate),
        sentSurveyDate: new Date(),
        userId: user_complete.userId,
        answerClients: answerClients,
        isAnonymous: allData?.surveyById.isAnonymous,
      },
    }).then((res) => {
      setOpenModal(true);
      if (res?.data?.saveAnswersSurvey?.anonymousSurveyId) {
        setAnonymousId(res.data.saveAnswersSurvey.anonymousSurveyId);
      }
      setShowLoader(false);
    });
  };

  const saveSurveyRating = () => {
    addfeedback({
      variables: {
        surveyId: allData?.surveyById.idSurvey,
        observation: refDescription.current.value,
        rating: surveyRating,
      },
    });
    history?.push({
      pathname: form ? `/Forms` : `/Survey`,
    });
  };

  const showSaveModal = () => {
    const colorInit = "#b7b7b7";

    [1, 2, 3, 4, 5].forEach((data, i) => {
      arrayImageRating = [
        ...arrayImageRating,
        <StarRoundedIcon
          key={i}
          id={i + 1}
          className="icon-selected-Survey-answer ImageRating"
          style={{
            fill: surveyRating >= i + 1 ? "#ffc502" : colorInit,
            cursor: "pointer",
          }}
          onClick={() => setSurveyRating(i + 1)}
        ></StarRoundedIcon>,
      ];
    });
    return openModal ? (
      <PortalModal>
        <ContentModalSaveSurveyAnswer>
          <CloseModalSurveyAnswer>
            {window.location.href.includes("TPCO") ? null : form ? (
              <Link to={`/Forms`}>
                <span>X</span>
              </Link>
            ) : (
              <Link to={`/Survey`}>
                <span>X</span>
              </Link>
            )}
          </CloseModalSurveyAnswer>
          <TextModalSurveyAnswer>
            <ThumbUpAltOutlinedIcon />
            <p>Your answers have been successfully submitted</p>
            {anonymousId && isAnonymous === "true" && (
              <>
                <p>Remember this token in case of personal feedback:</p>
                <p>
                  <b>{anonymousId}</b>
                  <IconButton>
                    <CopyIcon
                      onClick={() => navigator.clipboard.writeText(anonymousId)}
                    />
                  </IconButton>
                </p>
              </>
            )}
          </TextModalSurveyAnswer>
          <TextModalSurveyAnswer>
            <p>
              We would like to have your feedback and rating of this{" "}
              {form ? "form." : "survey."}
              Your opinion matter to us!
            </p>
            <div style={{ margin: "1em auto" }}>
              <SizeImgRating>{arrayImageRating.reverse()}</SizeImgRating>
            </div>
            <div style={{ width: "100%" }}>
              <textarea
                ref={refDescription}
                name="textarea"
                rows="4"
                style={{ width: "100%" }}
                placeholder="Type your observations here"
              ></textarea>
            </div>
          </TextModalSurveyAnswer>
          {window.location.href.includes("TPCO") ? null : (
            <ButtonSurveyAnswer onClick={() => saveSurveyRating()}>
              Send
            </ButtonSurveyAnswer>
          )}
        </ContentModalSaveSurveyAnswer>
      </PortalModal>
    ) : null;
  };

  const showWarningModel = () => {
    return warningModal ? (
      <PortalModal>
        <ContentModalSaveSurveyAnswer>
          <CloseModalSurveyAnswer>
            <span onClick={() => setWarningModal(false)}>X</span>
          </CloseModalSurveyAnswer>
          <TextModalSurveyAnswer>
            <InfoIcon />
            <p>
              It appears that there are some unanswered questions. Would you
              like to proceed with submitting the survey?
            </p>
          </TextModalSurveyAnswer>
          <div className="button-container">
            <ButtonSurveyAnswer onClick={() => saveSurveyAnswer()}>
              Submit
            </ButtonSurveyAnswer>
            <ButtonCancelSurvey onClick={() => setWarningModal(false)}>
              Close
            </ButtonCancelSurvey>
          </div>
        </ContentModalSaveSurveyAnswer>
      </PortalModal>
    ) : null;
  };

  const showSaveErrorModal = () => {
    return openErrorModal ? (
      <PortalModal>
        <ContentModalSaveSurveyAnswer>
          <CloseModalSurveyAnswer>
            <span onClick={() => setopenErrorModal(false)}>X</span>
          </CloseModalSurveyAnswer>
          <TextModalSurveyAnswer>
            <ThumbDownAltOutlinedIcon />
            <p>Your answers are not complete</p>
          </TextModalSurveyAnswer>
          <ButtonSurveyAnswer onClick={() => setopenErrorModal(false)}>
            Close
          </ButtonSurveyAnswer>
        </ContentModalSaveSurveyAnswer>
      </PortalModal>
    ) : null;
  };

  useEffect(() => {
    if (surveyQuestionData && surveyQuestionData.length) {
      surveyQuestionData.forEach((question) => {
        let configuration = JSON.parse(question.jsonConfiguration);
        if (configuration.typeQuestion === "InfoBanner") {
          let objImg = bannersSend.find((x) => x === question.idQuestion);
          if (!objImg) {
            bannersSend.push(question.idQuestion);
            getFile(configuration.questionSettings[0].nameImage).then(
              (response) => {
                if (response && response.type !== "archivo-noexistente/json") {
                  let obj = {
                    question: question.idQuestion,
                    url: URL.createObjectURL(response),
                  };
                  banners.push(obj);
                  setBanners([...banners]);
                }
              }
            );
          }
        }
      });
    }
  }, [banners, surveyQuestionData]);

  useEffect(() => {
    if (surveyQuestionData && surveyQuestionData.length) {
      surveyQuestionData.forEach((question) => {
        let configuration = JSON.parse(question.jsonConfiguration);
        if (configuration.typeQuestion === "MultipleChoiceImageSingleSelect") {
          let objImg = sigleImageSend.find((x) => x === question.idQuestion);
          if (!objImg) {
            sigleImageSend.push(question.idQuestion);
            configuration.answerList.forEach((element) => {
              getFile(element.image).then((response) => {
                if (response && response.type !== "archivo-noexistente/json") {
                  let obj = {
                    nameImage: element.image,
                    url: URL.createObjectURL(response),
                  };
                  imagesChoice.push(obj);
                  setImagesChoice([...imagesChoice]);
                }
              });
            });
          }
        }
      });
    }
  }, [imagesChoice, surveyQuestionData]);

  return (
    <div>
      <FillOutSurvey
        surveyData={surveyData}
        surveyQuestionData={surveyQuestionData}
        titleConfiguration={titleConfiguration}
        footerConfiguration={footerConfiguration}
        buttonSaveConfiguration={buttonSaveConfiguration}
        backgroundConfiguration={backgroundConfiguration}
        questionsConfiguration={questionsConfiguration}
        answerConfiguration={answerConfiguration}
        logoConfiguration={logoConfiguration}
        mandatoryMissing={mandatoryMissing}
        imgBackground={imgBackground}
        logoSurvey={logoSurvey}
        banners={banners}
        QuestionsSave={QuestionsSave}
        setQuestionsSave={setQuestionsSave}
        handleSaveSurvey={handleSaveSurvey}
        imagesChoice={imagesChoice}
        activeBtnSaveConfigPreview={preview}
        answersDependent={answersDependent}
        setAnswersDependent={setAnswersDependent}
      ></FillOutSurvey>

      {showSaveModal()}
      {showSaveErrorModal()}
      {showWarningModel()}
      {showLoader && <ModalLoader />}
      {showAnonymous && (
        <ModalConfirm
          info={`Please note that your responses will serve as anonymous to the author of the survey.`}
          handleConfirm={() => {}}
          setModalVisibility={setShowAnonymous}
          showCancel={false}
          modalTitle="Anonymous Response"
        />
      )}
    </div>
  );
};
export default FillOutSurveyContainer;

FillOutSurveyContainer.propTypes = {
  paramProp: PropTypes.string,
  previewProp: PropTypes.string,
  isAnonymousProp: PropTypes.string,
}